import ExportTableToCSV from "../DataTable/TableExportFunctions/exportTableToCSV";
import { ButtonsWrapper, Content, FormSection, InputWrapper, SectionLabel } from '../Forms/common';

function ExportPilotsLocations({ users, locationValues }) {

  //headers names keys pros to array
  const headerNames = [...users.reduce((s, o) => (Object.keys(o).forEach(k => s.add(k)), s), new Set)];
  const headerNamesLocations = [...locationValues.reduce((s, o) => (Object.keys(o).forEach(k => s.add(k)), s), new Set)];

  return (
  <FormSection>
    <SectionLabel>Exporting functions</SectionLabel>
    <Content>
      <InputWrapper>
       <label>Export drone pilots</label>
      </InputWrapper>
      <ButtonsWrapper>
       <ExportTableToCSV tableData={users} headers={headerNames}/>
      </ButtonsWrapper>
      <InputWrapper>
       <label>Export locations</label>
      </InputWrapper>
      <ButtonsWrapper>
       <ExportTableToCSV tableData={locationValues} headers={headerNamesLocations}/>
      </ButtonsWrapper>
    </Content>
  </FormSection>
  );
}
export default ExportPilotsLocations;